import { useEntitlements } from 'context/plan'

export const useV1Visible = (): boolean => {
  const { staffUncapped } = useEntitlements()
  return staffUncapped
}
